<template>
    <div class="col-sm-6 mb-30" data-match-height="confirm">
        <div class="metro-box-wrapper equal-height">
            <div class="heading">
                <h3>Información de Pago</h3>
            </div>
            <div class="content">
                <ul class="confirm-list inverse">
                    <li>
                        <span class="absolute">14.00€</span>
                        <span class="font600">Sala 1:</span><br/>
                        Videoconferencia, Catering
                    </li>

                    <li class="total bt mb-20">
                        <span class="absolute"><span class="price">14,00€</span><br/>2 horas, 1 Sala</span>
                        <strong>Total</strong><br/>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "roomInformation"
    }
</script>

<style scoped>
    .price {
        color: #8ac6c4 !important;
    }
</style>